import { render, staticRenderFns } from "./TermsCheckboxStory.vue?vue&type=template&id=dd0319ec&"
import script from "./TermsCheckboxStory.vue?vue&type=script&lang=ts&"
export * from "./TermsCheckboxStory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports